declare const createElement: any;
export default createElement;
